import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { valueStack, valuePriced, valueTotals, offers, media } from '../data/product';
import { CtaButton } from './CtaButton';
import { GuaranteeBadge, ShopHotspot } from './BannerOverlays';
export function ValueStackSection() {
  return <section aria-labelledby="value-heading" className="border-b border-white/10 bg-ink-950" data-id="element-1100" data-mp="1hcoy0f2grso2">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1101" data-mp="tn4arjza298z">
        <h2 id="value-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-1102" data-mp="oojcvr7i01np">
          The complete
          <br data-id="element-1103" data-mp="12lzl989cu5i3" />
          <span className="text-grit-500" data-id="element-1104" data-mp="ymz1nnj1yyu1">GritVue X1 system.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-1105" data-mp="yp3foyao1e81">
          Built for real work. The GritVue X1™ combines hands-free illumination, interchangeable lenses and a
          complete care system in one premium, work-ready package.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-1106" data-mp="1nbx9ctp35dob">
          <div className="border border-white/12 bg-ink-900" data-id="element-1107" data-mp="1sba19sutdaxr">
            <p className="border-b border-white/10 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400 sm:px-6" data-id="element-1108" data-mp="1wdn8klp7lgwn">
              Everything included
            </p>
            <ul data-id="element-1109" data-mp="21anbwouoc5k2">
              {valuePriced.map(row => <li key={row.item} className="flex items-start justify-between gap-5 border-b border-white/5 px-5 py-4 sm:px-6" data-id="element-1110" data-mp="14ns6rpk5zyr3">
                  <span className="min-w-0" data-id="element-1111" data-mp="1dmx2yp897g03">
                    <span className="block text-base font-semibold text-offwhite sm:text-lg" data-id="element-1112" data-mp="1dl2ifc0w9pwj">{row.item}</span>
                    <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-1113" data-mp="1ifqblo6uf8hg">{row.note}</span>
                  </span>
                  <span className="shrink-0 text-right" data-id="element-1114" data-mp="pxb8ug6qnqyy">
                    <span className="block font-display text-2xl font-bold leading-none text-steel-300" data-id="element-1115" data-mp="pvrrem9cj9vl">
                      {row.price}
                    </span>
                    {row.price.startsWith('$') && <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-steel-500" data-id="element-1116" data-mp="1o7kt3tobpc0h">
                        Value
                      </span>}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1117" data-mp="1a9w9sq9wmcxj">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1118" data-mp="15cmdqrs0f30q">
                Total separate value
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-1119" data-mp="1ea6c9syhml7n">
                {valueTotals.total}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1120" data-mp="2pqmutv5c9hyq">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-steel-400" data-id="element-1121" data-mp="2y75etia83f41">
                Regular complete system price
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-steel-400 line-through" data-id="element-1122" data-mp="2o97is8m4ge0v">
                {valueTotals.regular}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 bg-ink-850 px-5 py-4 sm:px-6" data-id="element-1123" data-mp="2ta59j9l76gdz">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1124" data-mp="3lwpxs16dmcdb">
                You save from regular price
              </span>
              <span className="text-right" data-id="element-1125" data-mp="375z8azs9bpdd">
                <span className="block font-display text-3xl font-extrabold leading-none text-grit-500" data-id="element-1126" data-mp="3c6el9q8mmuut">
                  {valueTotals.saveOne}
                </span>
                <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.18em] text-grit-500" data-id="element-1127" data-mp="8i33rtwrd9w3">
                  {valueTotals.discount}
                </span>
              </span>
            </div>

            <a href="#offer" className="group block bg-grit-500 px-5 py-6 text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offwhite sm:px-6" data-id="element-1128" data-mp="2c0azwwe32la8">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" data-id="element-1129" data-mp="2zq5g9nxm2rz8">This week&apos;s sale price</p>
              <p className="mt-2 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-1130" data-mp="2uqapdkdu62e6">
                <span className="font-display text-5xl font-extrabold leading-none sm:text-6xl" data-id="element-1131" data-mp="2pzkj84xl5vif">
                  {valueTotals.payOne}
                </span>
                <span className="pb-1.5 font-display text-lg font-bold uppercase sm:text-xl" data-id="element-1132" data-mp="2l0hdei9s7l9e">
                  for the complete system
                </span>
              </p>
              <p className="mt-3 font-display text-xl font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-1133" data-mp="3domyj64qzc9r">
                Or {valueTotals.payEach} per X1 with Buy 2, Get 1 Free.
              </p>
              <p className="mt-4 inline-flex items-center gap-2 font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-1134" data-mp="3q0fj5pogxu0g">
                Choose your pack
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-1135" data-mp="3s68z0n4lwv5" />
              </p>
            </a>
          </div>

          <div data-id="element-1136" data-mp="crt8ti07ium3">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1137" data-mp="crb7i6yotq7b">In every box</p>
            <ul className="mt-4 max-w-md" data-id="element-1138" data-mp="hlxii90uxgqv">
              {valueStack.map(item => <li key={item} className="flex items-center gap-3 border-b border-white/10 py-3.5 text-base font-medium text-offwhite sm:text-lg" data-id="element-1139" data-mp="mi5rt5sdifq4">
                  <CheckIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1140" data-mp="vjvho76lx6ls" />
                  {item}
                </li>)}
            </ul>

            <figure className="mt-8 border border-white/10 bg-ink-900" data-id="element-1141" data-mp="2nm7yoq93zbxy">
              <div className="relative" data-id="element-1142" data-mp="31d3c8fujyh7v">
                <img src={media.detailSheet} alt="The GritVue X1 frame with its light module, clear, amber and smoke lenses and USB-C charging" className="block h-auto w-full" data-id="element-1143" data-mp="31e4ognnb19r6" />
                <GuaranteeBadge compact box={{
                left: '17.2%',
                top: '37.4%',
                width: '17.4%',
                height: '9.2%'
              }} data-id="element-1144" data-mp="36bwqiahnyc93" />
                <ShopHotspot box={{
                left: '3.3%',
                top: '38.4%',
                width: '14.2%',
                height: '7%'
              }} data-id="element-1145" data-mp="3kammfmsqy5vv" />
              </div>
              <figcaption className="border-t border-white/10 px-4 py-3 text-[13px] text-steel-400" data-id="element-1146" data-mp="3g7zt1hgfgcwk">
                The X1 itself: illuminated frame, all three lenses and USB-C charging.
              </figcaption>
            </figure>

            <ul className="mt-6 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-1147" data-mp="1brmgaflqkxqb">
              {offers.map(offer => <li key={offer.id} data-id="element-1148" data-mp="1fsya6xbn854b">
                  <a href="#offer" aria-label={`${offer.units} for ${offer.price}. Go to pricing`} className={`block h-full px-4 py-4 transition-[background-color,transform] duration-150 ease-grit active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'bg-ink-900 hover:bg-ink-800'}`} data-id="element-1149" data-mp="1fvasjblbchhw">
                    <p className={`font-display text-xl font-extrabold uppercase leading-none ${offer.featured ? 'text-ink-950' : 'text-offwhite'}`} data-id="element-1150" data-mp="o20inwl0iqkf">
                      {offer.kicker}
                    </p>
                    <p className={`mt-1 font-display text-3xl font-extrabold leading-none ${offer.featured ? 'text-ink-950' : 'text-grit-500'}`} data-id="element-1151" data-mp="3r0h1sj3r1qbi">
                      {offer.price}
                    </p>
                    <p className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${offer.featured ? 'text-ink-950/70' : 'text-steel-400'}`} data-id="element-1152" data-mp="3d9lo8tib2l1l">
                      {offer.perUnit ?? offer.discountBadge ?? 'Single system'}
                    </p>
                  </a>
                </li>)}
            </ul>

            <p className="grit-headline mt-8 text-[clamp(1.75rem,6vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-1153" data-mp="2ub9fh8vb3d6j">
              See further.
              <br data-id="element-1154" data-mp="wjwziye2cyvs" />
              <span className="text-grit-500" data-id="element-1155" data-mp="widkfb458tvl">Work smarter.</span>
            </p>
            <p className="mt-3 text-[15px] font-semibold uppercase tracking-wide text-steel-300" data-id="element-1156" data-mp="sjweuw0dfrga">
              Built for the people who keep America moving.
            </p>
            <p className="mt-1 text-[13px] text-steel-500" data-id="element-1157" data-mp="2fejdlaju1g5q">Prescription ready.</p>

            <CtaButton offer="trio" className="mt-6 w-full sm:w-auto" data-id="element-1158" data-mp="2k6ayp5k7ytoh">
              Get 3 X1 Systems for $99.90
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}